import Helper from 'src/support/Helper';
import _, { isNumber, isObject } from 'underscore';
import resMaker from './responseMaker'

class ResponseMaker {
    data = [];
    data_to_send = {
        videoContentList: {
            searchFacets: [],
            list: [],
            count: 0
        }
    };

    constructor(data) {
        this.data = data;
    }

    process = async () => {
        let value = [];

        // Prepare Video List
        if (this.data.data.videoContentList !== undefined &&
            this.data.data.videoContentList !== null) {
            if (this.data.data.videoContentList.recordSetTotal !== undefined &&
                this.data.data.videoContentList.recordSetTotal !== null &&
                Number(this.data.data.videoContentList.recordSetTotal) > 0) {
                this.data_to_send.videoContentList.count = this.data.data.videoContentList.recordSetTotal;
            }

            if (this.data.data.videoContentList.webContentView !== undefined &&
                this.data.data.videoContentList.webContentView !== null &&
                Array.isArray(this.data.data.videoContentList.webContentView) &&
                this.data.data.videoContentList.webContentView.length > 0) {
                this.data.data.videoContentList.webContentView.map((v, i) => {
                    let here_v = {}
                    if (v['AssetName'] !== undefined) {
                        here_v.name = v['AssetName']
                    }
                    if (v['LongDescription'] !== undefined) {
                        here_v.longDesc = v['LongDescription']
                    }
                    if (v['AssetUrl'] !== undefined && v['AssetUrl'].includes('||')) {
                        here_v.url = '';
                        if (v['AssetUrl'].split('||').length > 1) {
                            here_v.url = 'https://players.brightcove.net/4598493563001/BkZJhSKu_default/index.html?videoId=' + v['AssetUrl'].split('||')[2];
                        }
                    }
                    value[i] = here_v;
                });
                this.data_to_send.videoContentList.list = value
            }
            // Prepare Search Facets
            if (this.data.data.videoContentList.FacetView !== undefined &&
                this.data.data.videoContentList.FacetView !== null &&
                this.data.data.videoContentList.FacetView.avn_filters_ntk_cs !== undefined &&
                this.data.data.videoContentList.FacetView.avn_filters_ntk_cs !== null) {
                let facetArr = [];
                if (Array.isArray(this.data.data.videoContentList.FacetView.avn_developmentstage_ntk_cs) &&
                    this.data.data.videoContentList.FacetView.avn_developmentstage_ntk_cs.length > 0) {
                    facetArr['DevelopmentStage'] = [];
                    this.data.data.videoContentList.FacetView.avn_developmentstage_ntk_cs.map((v, i) => {
                        if(facetArr['DevelopmentStage']['list'] === undefined)
                        {
                            facetArr['DevelopmentStage']['list'] = [];
                            facetArr['DevelopmentStage']['defaultFilter'] = 10;
                        }
                        facetArr['DevelopmentStage']['list'].push({
                            name: v['name'],
                            count: v.count,
                            filterName: ('avn_developmentstage_ntk_cs:' + v['name'])
                        });
                    });
                }
                if (Array.isArray(this.data.data.videoContentList.FacetView.avn_markets_ntk_cs) &&
                    this.data.data.videoContentList.FacetView.avn_markets_ntk_cs.length > 0) {
                    facetArr['Markets'] = [];
                    this.data.data.videoContentList.FacetView.avn_markets_ntk_cs.map((v, i) => {
                        if(facetArr['Markets']['list'] === undefined)
                        {
                            facetArr['Markets']['list'] = [];
                            facetArr['Markets']['defaultFilter'] = 10;
                        }
                        facetArr['Markets']['list'].push({
                            name: v['name'],
                            count: v.count,
                            filterName: ('avn_markets_ntk_cs:' + v['name'])
                        });
                    });
                }

                if (Array.isArray(this.data.data.videoContentList.FacetView.avn_technologies_ntk_cs) &&
                    this.data.data.videoContentList.FacetView.avn_technologies_ntk_cs.length > 0) {
                    facetArr['Technologies'] = [];
                    this.data.data.videoContentList.FacetView.avn_technologies_ntk_cs.map((v, i) => {
                        if(facetArr['Technologies']['list'] === undefined)
                        {
                            facetArr['Technologies']['list'] = [];
                            facetArr['Technologies']['defaultFilter'] = 10;
                        }
                        facetArr['Technologies']['list'].push({
                            name: v['name'],
                            count: v.count,
                            filterName: ('avn_technologies_ntk_cs:' + v['name'])
                        });
                    });
                }
                if (facetArr !== null && Object.keys(facetArr).length > 0) {
                    this.data_to_send.videoContentList.searchFacets = facetArr;
                }
            }
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}
export default ResponseMaker;